export default __webpack_public_path__ + "static/media/2.da043b68.png";